import { useEffect, useState } from 'react';

import assessmentPracticeScreenShown from '@hh.ru/analytics-js-events/build/career_platform/assessment_landing/assessment_practice_screen_shown';
import assessmentPracticeStartSkillButtonClick from '@hh.ru/analytics-js-events/build/career_platform/assessment_landing/assessment_practice_start_skill_button_click';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { ActionBar, Button, Cell, CellText, CheckableCard, Modal, VSpacingContainer } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { getCertStartTestCodeRouteHref } from 'src/app/routesUtils';
import useFeatureEnabled from 'src/hooks/useFeatureEnabled';
import { SKILL_JAVA, SKILLS_AVAILABLE_TO_TRAIN } from 'src/pages/CertLanding/fixtures';
import { AssessmentSkillDto } from 'src/pages/CertLanding/types';

import styles from './styles.less';

const Features = {
    enabledJavaTask: 'enabled_assessment_java_test_task',
};

const TrlKeys = {
    title: 'career-platform.page-cert-landing.section.screens.modal-start-practice.title',
    close: 'career-platform.page-cert-landing.section.screens.modal-start-practice.close',
    confirm: 'career-platform.page-cert-landing.section.screens.modal-start-practice.confirm',
};

interface Props {
    visible: boolean;
    onClose: () => void;
}

const ModalStartPractice: TranslatedComponent<Props> = ({ visible, onClose, trls }) => {
    const enabledJavaTask = useFeatureEnabled(Features.enabledJavaTask);
    const [selected, setSelected] = useState<AssessmentSkillDto | null>(null);

    const availableSkills = enabledJavaTask
        ? SKILLS_AVAILABLE_TO_TRAIN
        : SKILLS_AVAILABLE_TO_TRAIN.filter((item) => item.id !== SKILL_JAVA.id);

    const handleConfirm = () => {
        if (selected) {
            assessmentPracticeStartSkillButtonClick({
                skillId: selected.id,
                skillName: selected.name,
            });
        }
    };

    useEffect(() => {
        if (visible) {
            assessmentPracticeScreenShown();
        }
    }, [visible]);

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            title={trls[TrlKeys.title]}
            size="medium"
            footer={
                <ActionBar
                    secondaryActions={
                        <Button mode="tertiary" style="accent" onClick={onClose}>
                            {trls[TrlKeys.close]}
                        </Button>
                    }
                    primaryActions={
                        <Button
                            mode="primary"
                            style="accent"
                            disabled={!selected}
                            onClick={handleConfirm}
                            Element={SPALink}
                            to={getCertStartTestCodeRouteHref(selected?.id || 0)}
                            isSeoLink
                        >
                            {trls[TrlKeys.confirm]}
                        </Button>
                    }
                />
            }
        >
            <VSpacingContainer default={12}>
                {availableSkills.map((item) => (
                    <CheckableCard
                        key={item.id}
                        type="radio"
                        padding={16}
                        borderRadius={16}
                        checked={item.id === selected?.id}
                        onChange={() => setSelected(item)}
                    >
                        <Cell
                            avatar={<div className={styles.avatar} dangerouslySetInnerHTML={{ __html: item.icon }} />}
                        >
                            <CellText>{item.name}</CellText>
                            <CellText type="subtitle">{item.version}</CellText>
                        </Cell>
                    </CheckableCard>
                ))}
            </VSpacingContainer>
        </Modal>
    );
};

export default translation(ModalStartPractice);
